import { noop } from '@deltasierra/utilities-object';
import { Theme, createGenerateClassName, CssBaseline, MuiThemeProvider, StylesProvider } from '@material-ui/core';
import * as React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { DarkTheme } from './DarkTheme';
import { LightTheme } from './LightTheme';

export type ThemeName = 'dark' | 'light';

const themes: Record<ThemeName, Theme> = { dark: DarkTheme, light: LightTheme };

export type ThemeNameContextValue = {
    children?: React.ReactNode;
    themeName: ThemeName;
    setThemeName: React.Dispatch<React.SetStateAction<ThemeName>>;
};
export const ThemeNameContext = React.createContext<ThemeNameContextValue>({ setThemeName: noop, themeName: 'light' });

export type ThemeProviderProps = {
    children?: React.ReactNode;
    productionPrefix?: string;
    theme?: ThemeName;
};
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, productionPrefix, theme = 'light' }) => {
    const [themeName, setThemeName] = React.useState<ThemeName>(theme);

    const generateClassName = createGenerateClassName({ productionPrefix });

    return (
        <ThemeNameContext.Provider value={{ setThemeName, themeName }}>
            <StylesProvider generateClassName={generateClassName} injectFirst>
                <MuiThemeProvider theme={themes[themeName]}>
                    <StyledThemeProvider theme={themes[themeName]}>
                        <CssBaseline />
                        {children}
                    </StyledThemeProvider>
                </MuiThemeProvider>
            </StylesProvider>
        </ThemeNameContext.Provider>
    );
};
ThemeProvider.displayName = 'ThemeProvider';
